<template>
  <div class='demo-app' v-if="is_login">
    <div class='demo-app-sidebar'>        
      <div class='demo-app-sidebar-section'>
        <h2>Search</h2>
        <div class="form-group">
          <label>Search with meeting name</label>
          <input type="text" class="form-control" v-model="search_options.search_name" placeholder="Meeting name" @keyup="searchByMeetingName">
        </div>
        <div class="form-group">
          <label>Filter by users</label>
          <select class="form-control" @change=getSelected($event) id="users">
            <option value="">Select user</option>
            <option v-for="(item,i) in app_users" :key="i" :value="item.email">{{item.name}}</option>
          </select>
        </div>
         <div class="form-group">
          <label>Filter by institutions</label>
          <select class="form-control" @change=getSelectedInstitution($event) id="institutions">
            <option selected>Select Institution</option>
            <option v-for="(item,i) in app_institutions" :key="i" :value="item.ew_ins_id">{{item.ew_ins_name}}</option>
          </select>
        </div>
        <div class="form-group">
         <button class="button btn-primary" @click="clearFeelters">Clear Filters</button>
        </div>
      </div>
    </div>
    <div class='demo-app-main'>
      <FullCalendar
        v-if="is_login"
        class='demo-app-calendar'
        :options='calendarOptions'
      >
        <template v-slot:eventContent='arg'>
          <b>{{ arg.timeText }}</b>
          <i>{{ arg.event.title }}</i>
        </template>
      </FullCalendar>
    </div>
  </div>
</template>
<script>

import { INITIAL_EVENTS, createEventId } from './modules/event-utils'
import API from '../../services/api';
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import store from '../../store/index.js'
export default {
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  data: function() {
    return {
      search_options: {
        search_name:'',
        search_user:'',
        search_institution:0
      },
      //app_secret: this.$route.query.app,
      // default_url:'https://meetingservice.easy-web.cloud',
      app_secret:'28ca4053f9b1e28535d67e4218f3904f',
      default_url:'http://127.0.0.1:3003',
      user_email: 'albaruci@arkit.ch',
      secret:this.$route.params.id,
      app_users:[],
      app_institutions:[],
      is_login: false,
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          //interactionPlugin // needed for dateClick
        ],
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        initialView: 'dayGridMonth',
        //initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        // select: this.handleDateSelect,
        // eventClick: this.handleEventClick,
        // eventsSet: this.handleEvents,
        // resources: `http://127.0.0.1:3003/admin/28ca4053f9b1e28535d67e4218f3904f/resources`,
        events: function(info, successCallback, failureCallback) {
          API.get('/api/admin/meetings')
            .then(response => {
              successCallback(response.data)
            }).catch(response => {
              failureCallback(failureCallback);
            })
        },
        //events:  this.getAllMeetings
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      currentEvents: [],
      is_login:false
    }
  },
  /*computed: {
    userLogin() {
      return this.$store.state.auth.user;
    },
    isLogin(){
      return this.$store.state.auth.loggedIn
    }
  },*/
  async created(){
    
    this.urlparams = "shdb"
    this.calendarOptions.resources = `${this.default_url}/admin/${this.app_secret}/resources`;
    //this.calendarOptions.events= `/admin/${this.app_secret}/meetings`
    
    await this.handleLogin()
    await this.getApplicationUsers();
  },
  
  methods: {
    async getAllMeetings(info, successCallback, failureCallback) {
      API.get('/api/admin/meetings')
      .then(response => {
        successCallback(response.data)
      }).catch(response => {
        failureCallback(failureCallback);
      })
    },
    searchByMeetingName(){
      if(this.search_options.search_name.length > 1){
        this.filterMeetings()
      }
    },
    async filterMeetings(){
      var str1 = "?";
      let searchbyname = this.search_options.search_name != ''? `${this.search_options.search_name}`:'';
      let searchbyuser = this.search_options.search_user != ''? `${this.search_options.search_user}`:'';
      let searchbyinst = this.search_options.search_institution != 0 ? `${this.search_options.search_institution}`: 0;

      var res = `?search_name=${searchbyname}&search_user=${searchbyuser}&search_institution=${searchbyinst}`
      if(this.search_options.search_name.length > 2 || searchbyinst != 0 || searchbyuser !=''){
        // test= `${this.default_url}/admin/${this.app_secret}/meetings${res}`
        this.calendarOptions.events = await this.getAllMeetings
      }else{
        this.calendarOptions.events = `${this.default_url}/admin/${this.app_secret}/meetings`
      }
    },
    getSelected(event){
      this.search_options.search_user = event.target.value;
      this.filterMeetings()
    },
    getSelectedInstitution(event){
      this.search_options.search_institution = event.target.value;
      this.filterMeetings()
    },
    async getApplicationUsers(){
       await API.get(`/api/admin/applications`)
        .then((response) => {
          console.log(response)
          return
         this.app_users = data[0].users;
         this.app_institutions = data[0].institutions
         this.is_login = true;
        })
    },
    clearFeelters(){    
      document.querySelector('#users').selectedIndex        = 0;
      document.querySelector('#institutions').selectedIndex = 0;
      this.search_options = {
        search_name:'',
        search_user:'',
        search_institution:0
      }
       this.calendarOptions.events = `${this.default_url}/admin/${this.app_secret}/meetings`
    },
    async handleLogin(){
        await API.post(`/api/admin/login/${this.secret}`)
          .then(({data,status}) => {
            console.log(data,status)
            if(data.errorCode == 1){
              if(status == 400){
                this.$notification["error"]({
                    message: "Error",
                    description: data.errorMessage,
                  });
              }
            }
            if(data.errorCode == 0){
               const resp = data.data
                if (resp.access_token) {
                  localStorage.setItem('access_token', resp.access_token);
                  this.$store.dispatch('auth/getUser')
                  .then(response => {
                    store.commit('auth/getUserSuccess',response.data.profile)
                    this.is_login = true
                })
              }
             }
            
          }).catch(error => {
            this.$router.push('/login')
          })
    },
    handleWeekendsToggle() {
      this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
    },
    handleDateSelect(selectInfo) {
      return;
      let title = prompt('Please enter a new title for your event')
      let calendarApi = selectInfo.view.calendar
      calendarApi.unselect() // clear date selection
      if (title) {
        calendarApi.addEvent({
          id: createEventId(),
          title,
          start: selectInfo.startStr,
          end: selectInfo.endStr,
          allDay: selectInfo.allDay
        })
      }
    },
    handleEventClick(clickInfo) {
      // if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
      //   clickInfo.event.remove()
      // }
    },
    handleEvents(events) {
      this.currentEvents = events
    }
  }
};
</script>
<style lang='css'>

.demo-app {
  display: flex;
  min-height: 100%;
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
}
.demo-app-sidebar {
  width: 300px;
  line-height: 1.5;
  background: #eaf9ff;
  border-right: 1px solid #d3e2e8;
}
.demo-app-sidebar-section {
  padding: 2em;
}
.demo-app-main {
  flex-grow: 1;
  padding: 3em;
}
.fc { /* the calendar root */
  max-width: 1100px;
  margin: 0 auto;
}
</style>
